import { timeInterval } from 'd3-time';

// https://github.com/d3/d3-time/blob/master/src/month.js
export const timeMonthEnd = timeInterval(
    function (date) {
        date.setMonth(date.getMonth() + 1);
        date.setDate(0);
        date.setHours(0, 0, 0, 0);
    },
    function (date, step) {
        date.setMonth(date.getMonth() + step);
    },
    function (start, end) {
        return (
            end.getMonth() -
            start.getMonth() +
            (end.getFullYear() - start.getFullYear()) * 12
        );
    },
    function (date) {
        return date.getMonth();
    },
);
